export const initialNotify = {
  status: false,
  type: "",
  message: "",
  error: false,
};
